import { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Popover,
  OutlinedInput,
  Box,
  Divider,
  ListSubheader,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";

const getUniqueValues = (tableData) => {
  const uniqueValuesWithCategory = tableData
    .getAllColumns()
    ?.map((column) => {
      return {
        id: column.id,
        name: column.columnDef.header,
        columns: column.columns.map((el) => {
          return {
            id: el.id,
            name: el.columnDef.header,
          };
        }),
      };
    })
    .filter((column) => !(column.id === "edit"));
  return uniqueValuesWithCategory;
};

const ScrollPopup = ({ onClose, open, anchor, table }) => {
  const [displayList, setDisplayList] = useState(getUniqueValues(table));
  const [searchText, setSearchText] = useState("");
  console.log("running popup");

  useEffect(() => {
    setDisplayList(getUniqueValues(table));
  }, [table.getAllLeafColumns()]);

  const handleToggle = (selectedValue) => () => {
    const tableElem = document.querySelector(".main-table-live-view");
    const element = document.querySelector(
      `.${selectedValue?.id?.toLowerCase() + "_header_cell_"}`
    );
    const allColumns = table.getAllLeafColumns();
    const elemIndex = allColumns.findIndex((el) => el.id === selectedValue.id);
    console.log(
      elemIndex,
      "elem index",
      element,
      tableElem.parentElement.parentElement
    );
    tableElem.parentElement.scroll({
      // top: 0,
      left: (elemIndex - 1) * element?.clientWidth,
      behavior: "smooth",
    });
  };

  const handleSearch = (e) => {
    const uniqueValues = getUniqueValues(table);
    const searchTerm = e.target.value;
    setSearchText(searchTerm);
    setDisplayList(() => {
      if (searchTerm === "") {
        return [...uniqueValues];
      }
      if (searchTerm !== "") {
        const presentColumns = [];
        for (let i = 0; i < uniqueValues.length; i++) {
          const presentItems = uniqueValues[i].columns.filter((column) => {
            return column.name.toLowerCase().match(searchTerm.toLowerCase());
          });
          if (presentItems.length > 0) {
            presentColumns.push({
              ...uniqueValues[i],
              columns: presentItems,
            });
          }
        }
        return presentColumns;
      }
    });
  };

  return (
    <Popover
      marginThreshold={32}
      anchorEl={anchor}
      id={"filter-selector-popover"}
      open={open}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      style={{
        height: "400px",
        maxHeight: "400px",
      }}
      PaperProps={{
        style: {
          width: "270px",
          height: "400px",
          padding: "0.5rem",
          maxHeight: "400px",
        },
      }}
      onClose={onClose}
    >
      <Box
        display={"flex"}
        height={"100%"}
        flexDirection={"column"}
        alignItems={"space-between"}
        gridRowGap={"0.5rem"}
      >
        <Box width={"90%"} flexGrow={1} margin={"0 auto"}>
          <OutlinedInput
            id="search_inside_column"
            value={searchText}
            onChange={handleSearch}
            endAdornment={<Search />}
            fullWidth
            autoFocus
          />

          <List
            style={{
              overflowY: "scroll",
              maxHeight: "320px",
            }}
            subheader={<li />}
          >
            {displayList.length > 0 ? (
              displayList.map((subList) => {
                return (
                  <>
                    <ListSubheader style={{ backgroundColor: "#fff" }}>
                      {subList.name}
                    </ListSubheader>
                    {subList.columns.map((listItem, ind) => {
                      const { name: value, id } = listItem;
                      const labelId = `checkbox-list-label-${value}`;
                      return (
                        <ListItem
                          key={value}
                          button
                          onClick={handleToggle(listItem)}
                          dense
                        >
                          <ListItemText
                            id={labelId}
                            primary={value ? value : "(Blanks)"}
                          />
                        </ListItem>
                      );
                    })}
                  </>
                );
              })
            ) : (
              <ListItem>
                <ListItemText
                  style={{
                    textAlign: "center",
                    color: "#999",
                    fontSize: "8px",
                  }}
                >
                  No items found
                </ListItemText>
              </ListItem>
            )}
          </List>
          <Divider />
        </Box>
      </Box>
    </Popover>
  );
};
export default ScrollPopup;
